import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import * as yup from 'yup';
import {
  Button,
  TextField,
  FormControl,
  Fab,
  IconButton,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import { Search as SearchIcon, Close as CloseIcon } from '@material-ui/icons';
import BaseDialog from './BaseDialog';
import { useForm, useMediaInfo } from '../../utils/hooks';
import personApi from '../../apis/person.api';
import PersonList from '../../views/newIncident/PersonList';
import companyApi from '../../apis/company.api';
import CompanyList from '../../views/newIncident/CompanyList';
import { PersonDef } from '../propTypeDefs';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 600,
    flexGrow: 1,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  bottomMargin: {
    marginBottom: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
    // width: '100%',
  },
  formControlShort: {
    margin: theme.spacing(1),
    width: 150,
    // width: '100%',
  },
  formControlLong: {
    margin: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      minWidth: 400,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  formControlFull: {
    margin: theme.spacing(1),
    width: '100%',
  },
  lineItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // height: 80,
    flexWrap: 'wrap',
  },
  buttonSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    // alignItems: 'center',
    // height: 80,
    flexWrap: 'wrap',
  },
  cardDialogTitle: {
    display: 'flex',
  },
  cardDialogTitleText: {
    flexGrow: 1,
  },
}));

const SearchCompanyDialog = props => {
  const classes = useStyles();
  const { isSmaller } = useMediaInfo({ minBreakPoint: 'sm' });

  const [state, setState] = React.useState({
    searchName: undefined,
    invalidSearchForm: false,
    companies: props.companies,
  });

  const searchDialogTitle = () => {
    const titleText = 'Select Company';
    return (
      <div className={classes.cardDialogTitle}>
        <div className={classes.cardDialogTitleText}>{titleText}</div>
        <IconButton onClick={() => props.onClose()}>
          <CloseIcon />
        </IconButton>
      </div>
    );
  };

  const validateSearchForm = searchName => {
    const invalidSearchForm = !searchName;

    setState({ ...state, invalidSearchForm });
    return !invalidSearchForm;
  };

  const handleSearchChange = e => {
    const { name, value } = e.target;
    setState({ ...state, searchName: value });
  };

  const handleSearch = _.debounce(name => {
    if (!validateSearchForm(state.searchName)) return;

    companyApi.search(name).then(response => {
      setState({
        ...state,
        companies: response.data,
      });
    });
  }, 200);

  const inputKeyDown = event => {
    if (event.charCode === 13 || event.keyCode === 13) {
      const { name, value } = event.target;
      handleSearch(value);
    }
  };

  React.useEffect(() => {
    setState({
      ...state,
      companies: props.companies || [],
    });
  }, [props.companies]);

  const handleCompanyItemCommand = (command, value) => {
    props.onCompanySelected(value);
  };

  return (
    <BaseDialog
      open={props.open}
      maxWidth="md"
      title={searchDialogTitle()}
      onClose={() => props.onClose()}
      fullScreen={isSmaller}
    >
      {props.type === 'ADD' && (
        <div className={classes.searchForm}>
          <FormControl className={classes.formControl}>
            <TextField
              autoFocus
              name="name"
              label="Company name"
              placeholder="Enter company name"
              onChange={handleSearchChange}
              onKeyDown={inputKeyDown}
              error={state.invalidSearchForm}
              helperText={
                state.invalidSearchForm
                  ? 'Please enter "Company name".'
                  : undefined
              }
            />
          </FormControl>
          <Fab
            size="small"
            color="secondary"
            className={classes.button}
            onClick={() => handleSearch(state.searchName)}
          >
            <SearchIcon />
          </Fab>
        </div>
      )}

      <div className={classes.personList}>
        <CompanyList
          companies={state.companies || []}
          onItemCommand={handleCompanyItemCommand}
          type={props.type}
        />
      </div>
    </BaseDialog>
  );
};

SearchCompanyDialog.propTypes = {
  type: PropTypes.oneOf(['ADD', 'SELECT']),
  companies: PropTypes.arrayOf(PersonDef),
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onCompanySelected: PropTypes.func.isRequired,
};

SearchCompanyDialog.defaultProps = {
  onCloseIncident: () => {},
  onClose: () => {},
  type: 'ADD',
  searchName: '',
};

export default SearchCompanyDialog;
